import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { CommonButtonPopup } from '../../ReportsV2/styles';
// import { fetchApi } from '../../../utils/methods';
// import { toast } from 'react-toastify';
// import { PostCompanyAdminRewardTierConfig } from '../../../redux/constants/apiConstants';
import { InputContainer, StyledInputV2, StyledLabel } from '../../CreateEvent/style';
import { AdminCloseIcon } from '../../../utils/icons';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { CalendarHeader,StyledModal,Border, ConfirmPlanModalBody } from '../../RewardsManagement/Rewards/styles';
import { t } from 'i18next';
import { ColorPickerBox, ColorPickerText, ColorPickerWrapper, ColorPreview, HiddenColorInput } from './style';



const LinkModal = ({
  show,
  icon,
  title,
  onCancel,
  modalWidth = "500px",
  modalHeight,
  onClose,
  linkDetails,
  onChangeLinkDetails,
  //   history,
}) =>{

  const validateUrl = (url) => {
    try {
      new window.URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const isUrlValid = validateUrl(linkDetails?.url || "");
  const showUrlError = linkDetails?.url && !isUrlValid;


  const SelectPointTierLevels = () => {
    window.console.log("ihih")
    
    return (
      <>

        <div className="formBody" style={{width:'100%'}}>

          <InputContainer style={{margin:'20px 0px'}}>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{t("Heading Text")}{<span>*</span>}</StyledLabel>
            <StyledInputV2
              placeholder={t("Enter heading text")}
              name="heading_text"
              onChange={onChangeLinkDetails}
              value={linkDetails?.heading_text}
              maxLength="50"
              style={{background:"white"}}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
              // disabled={isCustomizedEvent}
            />
            <div className="count">{linkDetails?.heading_text?.length}/50 | C</div>
          </InputContainer>

          <InputContainer style={{marginBottom:'20px'}}>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{t("Add Button Text ")}{<span>*</span>}</StyledLabel>
            <StyledInputV2
              placeholder={t("Enter button text")}
              name="button_text"
              onChange={onChangeLinkDetails}
              value={linkDetails?.button_text}
              maxLength="30"
              style={{background:"white"}}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
              // disabled={isCustomizedEvent}
            />
            <div className="count">{linkDetails?.button_text?.length}/30 | C</div>
          </InputContainer>

          <InputContainer style={{marginBottom:'20px'}}>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{t("URL")}{<span>*</span>}</StyledLabel>
            <StyledInputV2
              placeholder={t("Enter url")}
              name="url"
              onChange={onChangeLinkDetails}
              value={linkDetails?.url}
              // maxLength="30"
              style={{background:"white"}}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
              // disabled={isCustomizedEvent}
            />
            {showUrlError && (<span style={{ color: "#DA6C74",fontFamily: "Lato",fontSize: '12px'}}>Please enter valid URL</span>)}
            {/* <div className="count">{title?.length}/30 | C</div> */}
          </InputContainer>

          <ColorPickerWrapper>
            <StyledLabel
              color={"#184A61"}
              fontSize={"16px"}
              margin={"0px 0px 8px 0px"}
            >
              Choose link Banner Color
            </StyledLabel>
          
            <ColorPickerBox
              onClick={() => document.getElementById("colorPickerInput").click()}
            >
              <ColorPickerText>Choose a color</ColorPickerText>
          
              <ColorPreview color={linkDetails?.banner_color} />
          
              <HiddenColorInput
                id="colorPickerInput"
                type="color"
                name="banner_color"
                value={linkDetails?.banner_color}
                onChange={onChangeLinkDetails}
              />
            </ColorPickerBox>
          </ColorPickerWrapper>

        </div>
     

        
      </>
    );
  };
      
    
  return(
    <StyledModal show={show} width={modalWidth} height={modalHeight}>
      <div className="modal-content-padding">
        <CalendarHeader style={{marginBottom:'0px'}}>
          <div className="left-content">
            {icon ? <div className="icon">{icon}</div> : null}
            <div>{title}</div>
          </div>
          <div className="close-icon" onClick={()=>onClose ? onClose() :onCancel()}>
            {AdminCloseIcon()}
          </div>
        </CalendarHeader>
        {/* <StyledLabel margin={'8px'} marginb={'20px'} style={{float:'unset'}}>Download a CSV of rewards activity based on your filters.</StyledLabel> */}
        <Border style={{marginTop:'20px'}}/>
  
      </div>

      <ConfirmPlanModalBody>

        {SelectPointTierLevels()}
      </ConfirmPlanModalBody>

      <Border/>
  
      <div className='footer'>
        <CommonButtonPopup height="48px" width="200px" disabled={!linkDetails?.heading_text || !linkDetails?.button_text || !linkDetails?.url || !isUrlValid} onClick={onCancel}>
        Submit
        </CommonButtonPopup>
  
      </div>
    </StyledModal>
  )};


LinkModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title:PropTypes.string, 
  onCancel: PropTypes.func.isRequired,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  icon: PropTypes.node.isRequired, 
  onClose:PropTypes.func,
  history:PropTypes.object,
  linkDetails:PropTypes.object,
  onChangeLinkDetails:PropTypes.func,
};

// const mapStateToProps = (state) => ({
//   departmentDetails: state.register.departmentDetails,
//   locationDetails: state.register.locationDetails,
// })

export default withRouter(connect(null , null)(withTranslation()(LinkModal)));
  
